import React, { Component } from 'react';
import _ from 'lodash';
import DisableNextModal from '../../../shared/Common/disableNextModal';
import CompetitorsTable from './CompetitorsTable/CompetitorsTable';


class CustomerGroupsLevel extends Component {
    constructor(props) {
        super(props);
        this.defaultParams;
        this.state = {
            createdData: false,
            editedData: false,
            deleteModalState: false,
            deletedItemId: null,
            stepSecondValidation: false,
        };
    }


    componentWillReceiveProps(nextProps) {
        if(this.props.competitiveAnalysis.addCompetitorsGroupsData !== nextProps.competitiveAnalysis.addCompetitorsGroupsData){
            let body = {
                projectId: this.props.projectId,
                type: 'competitors'
            }
            this.props.getCompetitorsGroups(body);
        }

        if (nextProps.competitiveAnalysis.competitorsGroupsData !== this.props.competitiveAnalysis.competitorsGroupsData ) {
            if (!_.isEmpty(nextProps.competitiveAnalysis.competitorsGroupsData.Items)) {
                this.defaultParams = nextProps.competitiveAnalysis.competitorsGroupsData.Items[0].competitors;
                let typeValue;
                for (let item of nextProps.competitiveAnalysis.competitorsGroupsData.Items[0].competitors) {
                    typeValue = item.type ? true : false;
                }
                typeValue ? this.setState({ stepSecondValidation: true }) : '';
            }
        }
    }

    changeCompetitorsGroupsImportant = (id) => {
        let count = 0
        for (let item of this.defaultParams) {
            if(item.competitorId === id ) {
                if(item.important){
                    item['important'] = false
                }else{
                    item['important'] = true
                }
            }
            if(item.important){
                count+=1
            }
        }
        if(count<4){
            this.setState({
                stepSecondValidation: true
            })
        }else{
            this.setState({
                stepSecondValidation: false
            })
        }
    }

    nextLevel = () => {
        let body = {
            type : 'competitors',
            id : this.props.competitiveAnalysis.competitorsGroupsData.Items[0].id,
            competitors : this.defaultParams,
            status : 'finished',
        }
        this.props.editCompetitorsGroups(body);
        this.props.groupStateNext();
    }

    elementInfiniteLoad() {
        return (
            <div className='col-sm-12'>
                <div className='spinner3'>
                    <div className='rect1' />
                    <div className='rect2' />
                    <div className='rect3' />
                    <div className='rect4' />
                    <div className='rect5' />
                </div>
            </div>
        );
    }

    render() {

        return (
            <div className='customer-groups-content'>
                <div className='step-bar'>
                    <div className='step step-five arrow-step'>
                        <p>Step 1</p>
                    </div>
                    <div className='step step-five arrow-step'>
                        <p>Step 2</p>
                    </div>
                    <div className='step step-five arrow-step'>
                        <p>Step 3</p>
                    </div>
                    <div className='step step-five arrow-step active-step'>
                        <p>Step 4</p>
                    </div>
                    <div className='step step-five arrow-step '>
                        <p>Result</p>
                    </div>
                </div>
                {!this.props.competitiveAnalysis.competitorsGroupsFetching &&
                    <div className='container-fluid'>
                        <div className="row">
                          <div className="col-sm-12">
                            <h5>COMPETITORS</h5>
                          </div>
                        </div>
                        <div className='row'>
                            <div className='col-xl-7 col-lg-8 col-md-10'>
                                <div className='card'>
                                    <div className='card-header'>
                                        <h5>Prioritize Competitors</h5>
                                        <span>Check the box of the 2-3 most important competitors </span>
                                    </div>
                                    <div className='card-body'>
                                       <CompetitorsTable
                                          data={this.props.competitiveAnalysis.competitorsGroupsData}
                                          changeCompetitorsGroupsImportant={this.changeCompetitorsGroupsImportant}
                                       />
                                    </div>
                                </div>
                            </div>

                            <div className='col-sm-12'>
                                <div className='card'>
                                    <div className='card-body'>
                                        <div onClick={this.state.stepSecondValidation ? this.nextLevel : this.props.disableNextModal} className='btn btn-success'> Next </div>
                                        <div onClick={this.props.groupStateBack} className='btn empty-btn default'> Back </div>
                                    </div>
                                </div>
                            </div>

                        </div>
                    </div>
                }
                {this.props.competitiveAnalysis.competitorsGroupsFetching &&
                    <div className='card'>
                        <div className="card-body">
                            {this.elementInfiniteLoad()}
                        </div>
                    </div>
                }
                { this.props.disableNextState &&
                    <DisableNextModal
                        disableNextState={this.props.disableNextState}
                        disableNextModal={this.props.disableNextModal}
                        disableModalText='Important competitors max count must be 3!'
                        disableModalTitle='Competitors Groups'
                    />

                }
            </div>
        )
    }
}

export default (CustomerGroupsLevel);



// WEBPACK FOOTER //
// ./src/components/CompetitiveAnalysis/CopmpetitorsGroupsImportant/CompetitorsGroupsImportant.jsx